import { GameConfigs } from '../../lib/globals/GameConfigs';
import useCoefData from '../helpers/useCoefData';
import { SymbolWrapper } from '../InfoStyled';
export default function SymbolPayouts({
	coefs,
	currentBet,
	slice,
	currency,
	text,
	name
}) {
	const [data] = useCoefData(coefs);
	return (
		<SymbolWrapper className='wrapper'>
			<div className='content_wrapper'>
				{text.map((item, id) => (
					<div
						key={id}
						className={
							name === 'additional' ? 'content additional_content' : 'content'
						}
					>
						<div
							style={id === 1 ? { color: '#CEEE71' } : { color: '#CEEE71' }}
							className='title'
						>
							{item.title}
						</div>
						<div className='description'>{item.desc}</div>
					</div>
				))}
			</div>
			<div className='symbol_container'>
				{data &&
					data.slice(slice.a, slice.b).map((item, id) => (
						<div key={id} className='symbol_wrapper'>
							<div className='symbol_box'>
								<div className='symbol'>
									<img src={item.icon} alt='symbol' />
								</div>
								<div className='coefs_wrapper'>
									{item.coef.map(
										(c, id) =>
											c !== 0 && (
												<div key={id} className='coefs'>
													<span>{id + 1}</span>
													<p>
														{(currency.length > 1 ? currency + ' ' : currency) +
															((c * currentBet) / 10).toLocaleString(
																undefined,
																{
																	minimumFractionDigits:
																		GameConfigs.config.currency_prec,
																	maximumFractionDigits:
																		GameConfigs.config.currency_prec
																}
															)}
													</p>
												</div>
											)
									)}
								</div>
							</div>
						</div>
					))}
			</div>
		</SymbolWrapper>
	);
}
